import { createFileRoute } from '@tanstack/react-router';
import { SetPasswordPage } from '@/auth/SetPasswordPage';

// Public — the recipient has no session yet. Token validity is only knowable
// server-side; an empty/missing token renders the error panel.
export const Route = createFileRoute('/accept-invite')({
  validateSearch: (search: Record<string, unknown>): { token: string } => ({
    token: typeof search.token === 'string' ? search.token : '',
  }),
  // Route-data exemption: unauthenticated, and everything it shows comes from the invite token in
  // the URL.
  component: Page,
});

function Page() {
  const { token } = Route.useSearch();
  return <SetPasswordPage mode="invite" token={token} />;
}
